import { SensorRoleTypeCodes } from '@kcftech/prometheustypescriptapiclient';
import { tokens } from 'styles/tokens';

/**
 * The maximum number tree indicator selections.
 */
export const MaxIndicatorSelections = 70;

/**
 * Default number of tree indicator selections.
 */
export const DefaultIndicatorSelections = 20;

/**
 * IndicatorTypesResponse retrieves data through the ID number for indicatorTypes,
 * so here we are using the ID's as the values for axialFilterOptions
 * and indicatorTypeOptions
 */
export const AxialFilterOptions = [
    { title: 'X Axis', value: SensorRoleTypeCodes.VibrationXAxis }, // '20'
    { title: 'Y Axis', value: SensorRoleTypeCodes.VibrationYAxis }, // '21'
];

export const DefaultCheckboxColor = tokens.grey.default;
export const DisabledCheckboxColor = tokens.border.default;
